import { AppTourStep, TooltipRelativePosition } from 'Components/AppTour';
import { NotifyReactEvents } from 'Phaser/EventBus2';
import { AppTourStepHelper } from 'Phaser/EventBus2/ToReact';
import { ApptourFeature } from 'Utils/AppTourFeatures';
import { NOT_GRADED_TEXT, NOT_GRADED_TITLE } from 'Utils/playAlong/ungradedTour';

/** The box around the top bar's accuracy control, which the "Not graded" tip points at. */
export const REPERTOIRE_ACCURACY_CONTROL_ID = 'rep-accuracy-control';

/**
 * The tip on the greyed accuracy control, in place of the graded tour's
 * accuracy step. Like that step it first folds the tempo panel away; it opens
 * nothing (the control does not open while grading is off).
 */
export const notGradedRepertoireStep: AppTourStep = {
  stepKey: 'repertoire_not_graded',
  targetId: REPERTOIRE_ACCURACY_CONTROL_ID,
  title: NOT_GRADED_TITLE,
  content: NOT_GRADED_TEXT,
  position: TooltipRelativePosition.LEFT,
  feature: ApptourFeature.UNGRADED_REPERTOIRE_ACCURACY,
  preStepFunction: () => {
    NotifyReactEvents.AppTourHelper({ step: AppTourStepHelper.EndTour });
  },
};
